export default __webpack_public_path__ + "static/media/1993.753a04e7.png";